var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfernew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2150_33887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6653 11.6672C16.8777 11.6674 17.0819 11.7488 17.2364 11.8946C17.3908 12.0404 17.4838 12.2397 17.4962 12.4517C17.5087 12.6637 17.4397 12.8725 17.3034 13.0354C17.167 13.1983 16.9737 13.3029 16.7628 13.328L16.6653 13.3339H5.34359L7.25442 15.2447C7.40388 15.3947 7.49065 15.5959 7.49711 15.8075C7.50357 16.0191 7.42924 16.2253 7.28921 16.3841C7.14919 16.5429 6.95396 16.6425 6.74319 16.6625C6.53242 16.6826 6.32191 16.6217 6.15442 16.4922L6.07609 16.423L2.88442 13.2314C2.33026 12.678 2.68526 11.7455 3.43692 11.6722L3.53276 11.6672H16.6653ZM12.7428 3.57804C12.8862 3.43456 13.0772 3.34836 13.2797 3.33563C13.4822 3.32289 13.6824 3.38449 13.8428 3.50887L13.9211 3.57804L17.1128 6.7697C17.6669 7.32304 17.3119 8.25554 16.5603 8.32887L16.4644 8.33387H3.33192C3.11952 8.33363 2.91523 8.2523 2.76078 8.1065C2.60633 7.96069 2.51339 7.76141 2.50095 7.54937C2.4885 7.33734 2.55748 7.12855 2.69381 6.96568C2.83013 6.8028 3.02351 6.69812 3.23442 6.67304L3.33192 6.6672H14.6536L12.7428 4.75637C12.5865 4.6001 12.4988 4.38817 12.4988 4.1672C12.4988 3.94623 12.5865 3.73431 12.7428 3.57804Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2150_33887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfernew);
export default __webpack_public_path__ + "static/media/transfernew.b8e9e370547d5af710b731d0f54eacf1.svg";
export { ForwardRef as ReactComponent };